import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

export default createUseStyles(
  {
    root: {
      width: 36,
      height: 36,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      border: [1, 'solid', 'transparent'],
      outline: 'none',
      borderRadius: 4,
      background: 'transparent',
      color: theme.colors.textPrimary,
      boxSizing: 'border-box',

      '&:hover': {
        background: theme.colors.backgroundSubtleHover,
      },

      '&:active': {
        background: theme.colors.backgroundSubtleActive,
      },

      '&:focus-visible': {
        borderColor: theme.colors.borderFocus,
      },
    },

    selected: {
      background: theme.colors.backgroundInteractive,
      color: theme.colors.textOnColorPrimary,

      '&:hover': {
        background: theme.colors.backgroundInteractiveHover,
      },

      '&:active': {
        background: theme.colors.backgroundInteractiveActive,
      },
    },

    disabled: {
      color: theme.colors.textDisabled,
      cursor: 'default',

      '&:hover': {
        background: 'transparent',
      },

      '&:active': {
        background: 'transparent',
      },
    },
  },
  {
    name: 'Day',
  },
);
